import { InjectionToken } from '@angular/core';

/** Parent host for the Activities tab (CODE_CLEANUP_SPEC Step 4). */
export const ACTIVITIES_HOST = new InjectionToken<any>('ACTIVITIES_HOST');
